import { Box } from '@mui/material';
import GoogleMapReact from 'google-map-react';
import { useEffect, useState } from 'react';
import { useGoogleMapsAPI } from '@/hooks/useGoogleMapsAPI';
interface Props {
  onChangeCoordinates: ({ lat, lng }: { lat: number; lng: number }) => void;
  value: { lat: number; lng: number };
  mapKey: string;
  disabled?: boolean;
  isActiveLock: boolean;
  isFullscreen?: boolean;
}
type Marker = {
  lat: number;
  lng: number;
  text: string;
};
export const ISSMap = ({
  onChangeCoordinates,
  value,
  mapKey,
  disabled,
  isActiveLock,
}: Props) => {
  // const [isEditingMap, setIsEditingMap] = useState<boolean>(true);
  const [clickedMarker, setClickedMarker] = useState<Marker | null>(null);
  const defaultProps = {
    zoom: 16,
  };

  const { isLoaded } = useGoogleMapsAPI(mapKey);

  // Helper function to validate and normalize coordinates
  const getValidCoordinates = (
    coords: { lat: number; lng: number } | null | undefined
  ) => {
    if (!coords || typeof coords !== 'object') {
      return { lat: 0, lng: 0 };
    }
    const lat =
      typeof coords.lat === 'number' && !isNaN(coords.lat) ? coords.lat : 0;
    const lng =
      typeof coords.lng === 'number' && !isNaN(coords.lng) ? coords.lng : 0;
    return { lat, lng };
  };
  const MarkerComponent = (_props: {
    lat: number;
    lng: number;
    text: string;
  }) => (
    <Box
      sx={{
        display: 'inline-block',
        backgroundColor: 'red',
        width: '20px',
        height: '20px',
        marginLeft: '-10px',
        marginTop: '-10px',
        borderRadius: '50%',
      }}
    ></Box>
  );
  const [mapCenter, setMapCenter] = useState(() => getValidCoordinates(value));

  useEffect(() => {
    // Update marker and map center when value changes, without triggering save
    const coords = getValidCoordinates(value);
    setClickedMarker({ lat: coords.lat, lng: coords.lng, text: 'My Marker' });
    setMapCenter(coords);
  }, [value]);
  const setNewCoordinates = (latitude: number, longitude: number) => {
    const lat = typeof latitude === 'number' && !isNaN(latitude) ? latitude : 0;
    const lng =
      typeof longitude === 'number' && !isNaN(longitude) ? longitude : 0;

    setClickedMarker({ lat, lng, text: 'My Marker' });
    onChangeCoordinates({ lat, lng });
  };
  const handleMapClick = (result: {
    lat: number;
    lng: number;
    event: unknown;
  }) => {
    if (disabled) return;
    // if (!isEditingMap) return;
    if (isActiveLock) return;

    const ignoredElements = ['BUTTON'];
    const eventTarget = result.event as { target?: { tagName?: string } };
    if (
      eventTarget.target?.tagName &&
      ignoredElements.includes(eventTarget.target.tagName)
    )
      return;

    setNewCoordinates(result.lat, result.lng);
  };

  return (
    <Box
      sx={{
        height: '345px',
        width: '100%',
        mt: '8px',
        borderRadius: '40px',
        opacity: disabled ? 0.4 : 1,
      }}
    >
      {mapKey && isLoaded ? (
        <GoogleMapReact
          bootstrapURLKeys={{ key: mapKey }}
          center={mapCenter}
          defaultZoom={defaultProps.zoom}
          onClick={handleMapClick}
          yesIWantToUseGoogleMapApiInternals={true}
        >
          {clickedMarker && (
            <MarkerComponent
              lat={clickedMarker.lat}
              lng={clickedMarker.lng}
              text={clickedMarker.text}
            />
          )}
        </GoogleMapReact>
      ) : (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: 'text.secondary',
          }}
        >
          Loading map...
        </Box>
      )}
    </Box>
  );
};
